"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mapbox_1 = require("../../initialize/mapbox");
var invoke_1 = __importDefault(require("lodash/invoke"));
var over_1 = __importDefault(require("lodash/over"));
var get_1 = __importDefault(require("lodash/get"));
var classnames_1 = __importDefault(require("classnames"));
var MapboxBase = /** @class */ (function (_super) {
    __extends(MapboxBase, _super);
    function MapboxBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { loaded: false };
        _this.componentWillUnmount = function () {
            _this.setMapLoaded = function () { return console.warn('Map loaded after unmount'); };
            _this.handleMapLoad = function () { return console.warn('Map loaded after unmount'); };
            _this.handleMapDrag = function () { return console.warn('Map dragged after unmount'); };
            _this.handleMapZoom = function () { return console.warn('Map zoomed after unmount'); };
            _this.handleMapClick = function () { return console.warn('Map clicked after unmount'); };
            invoke_1.default(_this.map, 'remove');
        };
        _this.getInitialCenter = function () { return __awaiter(_this, void 0, void 0, function () {
            var center;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, invoke_1.default(this.props, 'getInitialCenter')];
                    case 1:
                        center = _a.sent();
                        return [2 /*return*/, center || get_1.default(this.props.options, 'center')];
                }
            });
        }); };
        _this.renderLoader = function () {
            return invoke_1.default(_this.props, 'renderLoader') || null;
        };
        _this.setMapLoaded = function () {
            _this.setState({ loaded: true });
        };
        _this.handleMapLoad = function (ev) {
            invoke_1.default(_this.props, 'handleMapLoad', _this.map, ev);
        };
        _this.handleMapDrag = function (ev) {
            invoke_1.default(_this.props, 'handleMapDrag', _this.map, ev);
        };
        _this.handleMapZoom = function (ev) {
            invoke_1.default(_this.props, 'handleMapZoom', _this.map, ev);
        };
        _this.handleMapClick = function (ev) {
            invoke_1.default(_this.props, 'handleMapClick', _this.map, ev);
        };
        return _this;
    }
    MapboxBase.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var center, element;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!('mapboxgl' in window)) return [3 /*break*/, 2];
                        return [4 /*yield*/, mapbox_1.initializeMapbox()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!('mapboxgl' in window && !this.map)) return [3 /*break*/, 4];
                        window.mapboxgl.accessToken = this.props.accessToken;
                        console.log('Get initial center');
                        return [4 /*yield*/, this.getInitialCenter()];
                    case 3:
                        center = _a.sent();
                        console.log('Initial center', center);
                        element = document.getElementById(this.props.id || '');
                        console.log('Initial center', center);
                        if (!element) {
                            console.warn('No map element', this.props.id);
                            return [2 /*return*/];
                        }
                        this.mapboxgl = window.mapboxgl;
                        this.map = new window.mapboxgl.Map(__assign(__assign({ container: this.props.id || 'mapbox-container', style: 'mapbox://styles/mapbox/dark-v9', attributionControl: false }, this.props.options), { center: center }));
                        this.map.on('load', over_1.default([this.setMapLoaded, this.handleMapLoad]));
                        this.map.on('drag', this.handleMapDrag);
                        this.map.on('zoom', this.handleMapZoom);
                        this.map.on('click', this.handleMapClick);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MapboxBase.prototype.render = function () {
        var _a;
        var _b = this.props, id = _b.id, style = _b.style, className = _b.className, loadingClassName = _b.loadingClassName, loadingStyles = _b.loadingStyles;
        var loaded = this.state.loaded;
        return (react_1.default.createElement("div", { id: id || 'mapbox-container', style: __assign(__assign({}, style), (loaded ? loadingStyles : {})), className: classnames_1.default(className, (_a = {}, _a[loadingClassName || ''] = loaded, _a)) }, !loaded && this.renderLoader()));
    };
    return MapboxBase;
}(react_1.Component));
exports.MapboxBase = MapboxBase;
//# sourceMappingURL=Base.js.map